import React from 'react';
import {DomoLogoOneColorDark48} from 'images/ImageConstants';
import Square from 'components/activity/CSSSquare';
import LoadingStore from 'stores/LoadingStore';
import StyleSheet from 'utilities/StyleSheet';

class DomoFooterLogo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleChangeListener = this.handleChangeListener.bind(this);
  }

  componentDidMount() {
    LoadingStore.addChangeListener(this.handleChangeListener);
  }

  handleChangeListener() {
    this.forceUpdate();
  }

  componentWillUnmount() {
    LoadingStore.removeChangeListener(this.handleChangeListener);
  }

  render() {
    let content = null;
    const styles = this.getStyleSheet();

    if (LoadingStore.get()) {
      content = (
        <div style={{textAlign: 'center', padding: '16px 0px'}}>
          <Square />
        </div>
      );
    } else {
      content = (
        <div style={styles.Logo}>
          <img src={DomoLogoOneColorDark48} />
        </div>
      );
    }
    return content;
  }

  getStyleSheet() {
    return StyleSheet({
      Logo: {
        textAlign: 'center',
        padding: '16px 0px',
        opacity: 0.05,
      },
    });
  }
}

export default DomoFooterLogo;
